import LogLevel from '../constants/levels';
import { log } from './log';
import type { LogErrorObject } from '../types/LogErrorObject';
import type { CustomError } from '../types/CustomError';

export function warning(logObject: LogErrorObject, err?: CustomError, applicationUid: string | null = null) {
    log({
        level: LogLevel.WARNING,
        ...logObject,
        ex: {
            message: (err && err.message) as string,
            stackTrace: err && err.stack,
            errorCode: err && 'code' in err ? err.code : undefined,
            ...logObject.ex,
        }
    }, applicationUid)
}
